/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Member_Last_AdminInputs */

const es_co2_error_member_last_admin = /** @type {(inputs: Error_Member_Last_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La empresa debe mantener al menos un administrador.`)
};

/**

* @param {Error_Member_Last_AdminInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_member_last_admin = /** @type {((inputs?: Error_Member_Last_AdminInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Member_Last_AdminInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_member_last_admin(inputs)
});